// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-billing-invoice-list .CcmList-Column-Wide {
  min-width: 360px;
}`, "",{"version":3,"sources":["webpack://./Source/app/customer-billing/customer-billing-invoice/customer-billing-invoice-list/customer-billing-invoice-list.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR","sourcesContent":[".fi-customer-billing-invoice-list {\r\n    .CcmList-Column-Wide {\r\n        min-width: 360px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
